export default __webpack_public_path__ + "static/media/AMZN_DE_BULKY.19c47d78.svg";